/* 画面モード */
export enum PageModeEnum {
  Create = 'create',
  Copy = 'copy',
  Update = 'update',
  Detail = 'detail',
  History = 'history',
  ReadOnly = 'readOnly'
}
export type PageMode = PageModeEnum;

export enum UserRoleEnum {
  Admin = 'ADMIN',
  Applicant = 'APPLICANT'
}
export type UserRole = UserRoleEnum;

export enum UserGroupEnum {
  CommandCenter = 'COMMAND_CENTER',
  HeadOffice = 'HEAD_OFFICE',
  Station = 'STATION',
  Onboard = 'ONBOARD',
  Contractor = 'CONTRACTOR'
}
export type UserGroup = UserGroupEnum;

export enum WorkflowTypeEnum {
  Calendar = 'CALENDAR',
  TrainSchedule = 'TRAIN_SCHEDULE',
  TrainAssignment = 'TRAIN_ASSIGNMENT'
}
export type WorkflowType = WorkflowTypeEnum;

/* ダッシュボード画面からワークフロー対象機能の詳細ページへの遷移パス定数 */
export const workflowTypeDetailPagePathMap: Record<WorkflowType, string> = {
  [WorkflowTypeEnum.Calendar]: '/calendars',
  [WorkflowTypeEnum.TrainSchedule]: '/train-services',
  [WorkflowTypeEnum.TrainAssignment]: '/train-assignments'
};

export enum WorkflowStatusEnum {
  Unsubmitted = '',
  Cancelled = 'CANCELLED',
  Submitted = 'SUBMITTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}
export type WorkflowStatus = WorkflowStatusEnum;

/** 予約状態 */
export enum OrderStatusEnum {
  Reserved = 'RESERVED', // 予約済
  Cancelled = 'CANCELLED' // キャンセル済
}
export type OrderStatus = OrderStatusEnum;

export enum OrderOperationEnum {
  NewBooking = 'NEW_BOOKING', // 新規作成
  SeatChanged = 'SEAT_CHANGED', // 座席変更
  SeatRelease = 'SEAT_RELEASE', // 座席開放
  TicketPrinted = 'TICKET_PRINTED', // 伝票印刷
  Cancelled = 'CANCELLED', // 予約取消
  History = 'HISTORY' // 予約変更履歴詳細 （画面モード判定用）
}
export type OrderOperation = OrderOperationEnum;

/** 車両運行状況 */
export enum TrainOperationStatusEnum {
  Normal = 'NORMAL', // 通常運行
  Suspended = 'SUSPENDED', // 運休
  PartialSuspended = 'PARTIAL_SUSPENDED' // 部分運休
}
export type TrainOperationStatus = TrainOperationStatusEnum;

/* 席調整タイプ */
// API / DB で使う値
export enum AdjustmentTypeEnum {
  Common = '1',
  // 便別は一旦タブ表示なしです https://applink.larksuite.com/client/message/link/open?token=AmiUAFqmAAAgaQDA9hOATuA%3Dください。
  // Individual = '2'
  SeatTypeChange = '3'
}
// UI 側で使うtab の key や i18n の表示にマップ
export const adjustmentTypeMap = {
  [AdjustmentTypeEnum.Common]: 'common'
  // [AdjustmentTypeEnum.Individual]: 'individual'
  // SeatTypeChange は席調整一覧のtabには表示しないので、ここに追加しないでください
};
// 型 "1" | "2"
export type AdjustmentType = AdjustmentTypeEnum.Common;

export enum DirectionFlagEnum {
  Up = 'UP',
  Down = 'DOWN'
}
export type DirectionFlag = DirectionFlagEnum;

/* ダイヤタイプ */
export enum TrainScheduleTypeEnum {
  WeekDay = 1,
  HoliDay = 2
}
export type TrainScheduleType = TrainScheduleTypeEnum;

// UI 側で i18n の表示にマップ
export const trainScheduleTypeMap: Record<TrainScheduleType, string> = {
  [TrainScheduleTypeEnum.WeekDay]: 'weekday',
  [TrainScheduleTypeEnum.HoliDay]: 'holiday'
};

export const FILE_CSV_TYPE = 'text/csv';

export enum CalendarTypeEnum {
  Weekday = 1, // 平日
  Holiday = 2, // 休日
  Disabled = 3 // 運行適用期間外
}
// UI側で使う i18n の表示にマップ
export const calendarTypeMap = {
  [CalendarTypeEnum.Weekday]: 'weekday',
  [CalendarTypeEnum.Holiday]: 'holiday',
  [CalendarTypeEnum.Disabled]: 'disabled'
};
export type CalendarType = CalendarTypeEnum;

// 座席予約の座席ボックスの選択肢
export const BOX_NAME_OCCUPIED_COUNT_OPTIONS = [
  // boxName: string, occupiedCount: string
  { label: '', value: '' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' }
];

// 4号車の座席ラベルマップ seatNo → seatLabel (A, B, C, D)
export const car4SeatLabelMap: Record<string, string> = {
  '1': 'A',
  '2': 'B',
  '3': 'C',
  '4': 'D'
};

// 曜日
export enum WeekTypeEnum {
  Sun = 0,
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6
}
export type WeekType = WeekTypeEnum;
export const weekTypeMap: Record<WeekType, string> = {
  [WeekTypeEnum.Sun]: 'sun',
  [WeekTypeEnum.Mon]: 'mon',
  [WeekTypeEnum.Tue]: 'tue',
  [WeekTypeEnum.Wed]: 'wed',
  [WeekTypeEnum.Thu]: 'thu',
  [WeekTypeEnum.Fri]: 'fri',
  [WeekTypeEnum.Sat]: 'sat'
};

// 購入区分
export enum PurchaseChannelEnum {
  Internal = 'INTERNAL', // 本社／指令
  Web = 'WEB', // WEB
  OnSite = 'ON_SITE' // 車内
}
export type PurchaseChannel = PurchaseChannelEnum;

export enum BusinessModuleEnum {
  Empty = '',
  WebMaster = 'WEB_MASTER',
  WebOperation = 'WEB_OPERATION',
  WebUser = 'WEB_USER',
  OnboardSales = 'ONBOARD_SALES'
}
export type BusinessModule = BusinessModuleEnum;

export enum BusinessItemEnum {
  Empty = '',
  RollingStock = 'ROLLING_STOCK',
  Station = 'STATION',
  Calendar = 'CALENDAR',
  SeatDiagram = 'SEAT_DIAGRAM',
  RollingStockAssignment = 'ROLLING_STOCK_ASSIGNMENT',
  Suspension = 'SUSPENSION',
  TrainReservation = 'TRAIN_RESERVATION',
  ReservationDetail = 'RESERVATION_DETAIL',
  SeatClass = 'SEAT_CLASS',
  ExpressTicketSale = 'EXPRESS_TICKET_SALE',
  ExpressTicketDetail = 'EXPRESS_TICKET_DETAIL',
  Account = 'ACCOUNT'
}
export type BusinessItem = BusinessItemEnum;

export const businessModuleDetailMap: Record<BusinessModule, BusinessItem[]> = {
  [BusinessModuleEnum.Empty]: [BusinessItemEnum.Empty],
  [BusinessModuleEnum.WebMaster]: [
    BusinessItemEnum.RollingStock,
    BusinessItemEnum.Station,
    BusinessItemEnum.Calendar,
    BusinessItemEnum.SeatDiagram,
    BusinessItemEnum.RollingStockAssignment,
    BusinessItemEnum.Suspension
  ],
  [BusinessModuleEnum.WebOperation]: [
    BusinessItemEnum.TrainReservation,
    BusinessItemEnum.ReservationDetail,
    BusinessItemEnum.SeatClass
  ],
  [BusinessModuleEnum.WebUser]: [BusinessItemEnum.Account],
  [BusinessModuleEnum.OnboardSales]: [
    BusinessItemEnum.ExpressTicketSale,
    BusinessItemEnum.ExpressTicketDetail
  ]
};
